import { useTranslation } from "react-i18next";

import { HaNContext } from "@lib/logic";
import { getFloorById, getPreferences, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";

import { HaNResultList } from "./HaNResultList/HaNResultList";

// The floor the list shows, and whether it's the user's preferred floor (the one the page opens on)
export const SelectedFloorHeader = () => {
  const { t } = useTranslation();
  const { floor } = useRequiredContext(HaNContext);
  const selectedFloor = useAppSelector(state => getFloorById(state, floor.floorId ?? ""));
  const preferredFloorId = useAppSelector(state => getPreferences(state).workspaceLocation?.floorId);

  if (!selectedFloor) return null;

  return (
    <HaNResultList.Header title={`${t("Floor")} ${selectedFloor.number}`}>
      {selectedFloor.id === preferredFloorId && <p>{t("YourPreference")}</p>}
    </HaNResultList.Header>
  );
};
